<template>
  <div class="honor-swiper">
    <div class="grid">
      <div v-for="item in items" :key="item.title" class="card">
        <div class="img">
          <img :src="item.image" :alt="item.title" />
        </div>
        <div class="label">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HonorSwiper',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.honor-swiper { padding: 40px 0 80px; }
.grid {
  width: 1085px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 48px 64px;
}
.card { text-align: center; color: #929292; }
.img {
  width: 209px;
  height: 139px;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
}
.img img { width: 100%; height: 100%; object-fit: cover; }
.label { margin-top: 16px; font-size: 16px; }
</style>

